var data = [{
  label: 'Long icon button label',
  iconName: 'PrepaidIcon',
  type: 'secondary',
  onPress: {}
}, {
  label: 'Postpaid',
  iconName: 'PrepaidIcon',
  type: 'secondary',
  onPress: {}
}, {
  label: 'DTH',
  iconName: 'PrepaidIcon',
  type: 'secondary',
  onPress: {}
}, {
  label: 'Fiber',
  iconName: 'PrepaidIcon',
  type: 'secondary',
  onPress: {}
}, {
  label: 'Gas',
  iconName: 'PrepaidIcon',
  type: 'secondary',
  onPress: {}
}, {
  label: 'Electricity',
  iconName: 'PrepaidIcon',
  type: 'secondary',
  onPress: {}
}, {
  label: 'Water',
  iconName: 'PrepaidIcon',
  type: 'secondary',
  onPress: {}
}, {
  label: 'xSafe',
  iconName: 'PrepaidIcon',
  type: 'secondary',
  onPress: {}
}, {
  label: 'xStream',
  iconName: 'PrepaidIcon',
  type: 'secondary',
  onPress: {}
}, {
  label: 'View More',
  iconName: 'DownChevronIcon',
  type: 'primary',
  onPress: {}
}];
export var defaultProps = {
  data,
  useNewStyle: false,
  onUserAction: console.log
};